/**
 * Components
 */
import ProductsTable from './ProductsTable';

export default {
    props: ['title', 'slug', 'entries', 'count', 'product-type', 'activeModelSearchTerm', 'id', 'siblingProductPages'],

    data() {
        return {
            showToggled: false,
        };
    },

    components: {
        'products-table': ProductsTable,
    },
    watch: {
        activeModelSearchTerm() {
            this.showToggled = this.hasActiveProduct();
        },
    },
    methods: {
        /**
         * Toggle Manufacturer section
         */
        hasActiveProduct() {
            const productsKeys = Object.keys(this.entries);
            let activeProductFound = false;
            productsKeys.forEach((key) => {
                this.entries[key].forEach((product) => {
                    activeProductFound = product.modelNumber === this.activeModelSearchTerm || activeProductFound;
                });
            });
            return activeProductFound;
        },
        toggleShow() {
            if (this.showToggled) {
                // wrap.classList.remove('toggled');
                this.showToggled = false;
            } else {
                // wrap.classList.add('toggled');
                this.showToggled = true;

                if ('dataLayer' in window) {
                    window.dataLayer.push({
                        event: 'manufacturerToggle',
                        manufacturer: this.title,
                    });
                }
            }
        },
    },

    template: `
        <article class="products-entry" :class="{'toggled' : showToggled}" :id="slug">
            <header class="products-entry__header pt-lg pb-lg" v-on:click="toggleShow($event)">
                <div class="products-entry__count">
                    {{ count }}
                </div>

                <div class="products-entry__title h4">
                    <h1>{{title}}</h1>
                </div>

                <div class="products-entry__icon">
                    <div class="plus-minus ">
                        <svg class="icon plus-minus__plus-outline">
                            <use xlink:href="#plus-outline"></use>
                        </svg>
                        <svg class="icon plus-minus__plus-solid">
                            <use xlink:href="#plus-solid"></use>
                        </svg>
                        <svg class="icon plus-minus__minus-outline">
                            <use xlink:href="#minus-outline"></use>
                        </svg>
                        <svg class="icon plus-minus__minus-solid">
                            <use xlink:href="#minus-solid"></use>
                        </svg>
                    </div>
                </div>
            </header>

            <div class="products-entry__toggled-content">
                <products-table
                    v-for="(value, key) in entries"
                    :product-type="productType"
                    :title="key"
                    :products="value"
                    :key="title + ' - ' + key"
                    :active-model-search-term="activeModelSearchTerm"
                >
                </products-table>
                <h2 v-if="siblingProductPages.length > 0" class="h4 mb-sm mt-xl">Other Products</h2>
                <a v-for="siblingPage in siblingProductPages"
                    :href="siblingPage.url + '?manufacturer=' + title + '&manufacturerId=' + id"
                    class="arrowlink mr-md mb-xxl" target="_self">
                    View {{ siblingPage.title }}
                    <div class="arrowlink__icon-wrap">
                        <svg class="icon ">
                            <use xlink:href="#arrow-right"></use>
                        </svg>
                    </div>
                </a>
            </div>
        </article>
    `,
};
